<template>
  <div class="room-product">
    <b-row>
      <b-col md="7">
        <occupancy-product class="mb-2" :maximum_occupancy="product_info.product.maximum_occupancy" />
        <div class="room-product__policies">
          <mealplan
            class="mb-2"
            v-if="product_info.product.policies.meal_plan.meals.length"
            :meals="product_info.product.policies.meal_plan.meals"
          />
          <refundability :cancellation="product_info.product.policies.cancellation"  />
        </div>
      </b-col>
      <b-col md="5" align-self="end">
        <div class="room-product__selector">
          <room-selector :product_info="product_info" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Mealplan from '@bookingv3/components/atoms/mealplan'
import Refundability from '@bookingv3/components/atoms/refundability'
import RoomSelector from '@bookingv3/components/blocks/detail/room/room-selector'
import OccupancyProduct from '@bookingv3/components/blocks/occupancy-product'

export default {
  name: 'room-product',

  components: {
    'mealplan': Mealplan,
    'refundability': Refundability,
    'room-selector': RoomSelector,
    'occupancy-product': OccupancyProduct,
  },

  props: {
    product_info: Object,
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .room-product {
    background-color: $white;
    padding: $grid-gutter-width/2;
    border-radius: $grid-gutter-width/3;
    border: 1px solid transparent;

    @include media-breakpoint-up(xl){
      margin-left: -1rem;
    }

    &__selector {
      position: relative;
      margin-top: 15px;

      @include media-breakpoint-up(md){
        margin-top: 0;
      }
    }
  }

</style>